import type { ReportAccessItem } from '../models/reportAccess.types'
import { REPORT_STATUS_AVAILABLE, SUMMARY_REPORT_ID } from '../models/reportAccess.types'
import { useReportAccessStore } from '../stores/reportAccessStore'

import { useReportSchedules } from './useReportSchedules'

export interface UseReportAccess {
  reportById: (reportId: number) => ReportAccessItem | null
  checkReport: (reportId: number) => boolean
  reportsByType: (type: string) => readonly ReportAccessItem[]
  reportKey: (reportId: number) => string | undefined
}

/** Module 08's report availability surface for shell navigation and report-page gates. */
export function useReportAccess(): UseReportAccess {
  const store = useReportAccessStore()
  const schedules = useReportSchedules()

  const reportById = (reportId: number): ReportAccessItem | null => store.reportById(reportId)

  const checkReport = (reportId: number): boolean => {
    if (reportById(reportId)?.status !== REPORT_STATUS_AVAILABLE) return false
    if (reportId === SUMMARY_REPORT_ID) return true
    const schedule = schedules.getScheduleByReportId(reportId)
    return schedule !== null && schedule.additional_info !== null
  }

  return {
    reportById,
    checkReport,
    reportsByType: (type) => store.reportsByType(type),
    reportKey: (reportId) => reportById(reportId)?.key ?? undefined,
  }
}
